module.exports = __webpack_public_path__ + "img/pic1.c47ba0ae.png";